export default __webpack_public_path__ + "static/media/informationOverload.c746fa5a.svg";